import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AppLocation } from '../../../core/models/interface/geo';
import {
  BUYFLOW_MAP_MAX,
  BUYFLOW_MAP_MIN,
  MapBounds,
  MapBoundsAndZoom,
} from '../app-buyflow-map/app-buyflow-map.component';
import LatLngBounds = google.maps.LatLngBounds;
import { GoogleMap } from '@angular/google-maps';
import LatLngLiteral = google.maps.LatLngLiteral;

@Component({
  selector: 'app-marker-map',
  templateUrl: './app-marker-map.component.html',
  styleUrls: ['./app-marker-map.component.scss'],
})
export class AppMarkerMapComponent implements OnInit, AfterViewInit {
  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;

  /**
   * location is the center point of the map along with the marker location to be displayed,
   * map center is defined with location.mapLatitude and location.mapLongitude,
   * map marker is defined with location.markerLatitude and location.markerLongitude,
   */
  @Input()
  location: Partial<AppLocation>;

  /**
   * Default to false, If this is set to true, this will allow the user to move the map with their mouse
   */
  @Input()
  setMapDraggable: boolean;

  /**
   *zoomUpdate will emit any update in the zoom of the map
   */
  @Output()
  zoomUpdate = new EventEmitter<MapZoom>();

  /**
   * boundsUpdateEmit will emit any update of the bounds of the map and give you the center point of the map along
   * with the map bounds
   */
  @Output()
  boundsUpdateEmit = new EventEmitter<MapBoundsAndZoom>();

  private zoom: MapZoom;
  isMapDraggable: boolean;
  boundsTimeout: any = null;
  options: google.maps.MapOptions = {
    disableDefaultUI: true,
    zoomControl: true,
    draggable: false,
  };
  private mapSettled: boolean;
  mapPosition: LatLngLiteral;
  markerPosition: LatLngLiteral;

  constructor() {}

  ngOnInit() {
    if (!this.location) {
      this.location = {
        zoom: 3,
        mapLatitude: 40,
        mapLongitude: -95.7129,
        markerLatitude: 40,
        markerLongitude: -95.7129,
      };
    }
    this.mapPosition = {
      lat: this.location.mapLatitude,
      lng: this.location.mapLongitude,
    };
    this.markerPosition = {
      lat: this.location.markerLatitude,
      lng: this.location.markerLongitude,
    };
    this.isMapDraggable = this.setMapDraggable ? this.setMapDraggable : false;
    this.options.draggable = this.isMapDraggable;
  }

  ngAfterViewInit() {
    this.mapSettled = true;
  }

  setZoom($event: number) {
    this.zoom = { zoom: $event };
    this.zoomUpdate.emit(this.zoom);
  }

  onBoundChangeEvent(): void {
    if (this.mapSettled) {
      if (this.location && !this.location.mapLatitude) {
        this.location.mapLatitude = this.location.position.lat;
        this.location.mapLongitude = this.location.position.lng;

        this.mapPosition = {
          lat: this.location.mapLatitude,
          lng: this.location.mapLongitude,
        };
      }

      let bounds = this.map.getBounds();

      if (this.boundsTimeout) {
        clearTimeout(this.boundsTimeout);
      }

      if (bounds) {
        this.boundsTimeout = setTimeout(() => {
          const mapBounds: MapBounds = {
            northEastLat: bounds.getNorthEast().lat(),
            northEastLng: bounds.getNorthEast().lng(),
            southWestLat: bounds.getSouthWest().lat(),
            southWestLng: bounds.getSouthWest().lng(),
          };
          const boundsAndZoom: MapBoundsAndZoom = {
            mapBounds: mapBounds,
            center: {
              latitude: (mapBounds.northEastLat + mapBounds.southWestLat) / 2,
              longitude: (mapBounds.northEastLng + mapBounds.southWestLng) / 2,
            },
          };

          this.markerPosition = {
            lat: boundsAndZoom.center.latitude,
            lng: boundsAndZoom.center.longitude,
          };

          this.boundsUpdateEmit.emit(boundsAndZoom);
        }, 10);
      }
    }
  }

  zoomChanged() {
    this.zoomUpdate.emit({ zoom: this.map.getZoom() });
  }
}

export interface MapZoom {
  zoom: number;
}
